export const prodotto = {
  codice: '',
  dataInizioVal: null,
  dataFineVal: null,
  title: '',
  dataInserimento: null,
  dataVariazione: null,
  tipo: '',
};